module.exports = __webpack_public_path__ + "static/media/earthquake-sky-blue.c6c273ff.svg";